import { useContext } from "react";
import { ResilientAxiosContext } from "./ResilientAxiosContext";

export function useResilientAxios() {
  const context = useContext(ResilientAxiosContext);
  const activeChatEndpoint = context.activeEndpoint
    ? context.activeEndpoint.replace("api", "chat") + "/v1/"
    : "";
  const activeWSEndpoint = context.activeEndpoint
    ? context.activeEndpoint
        .replace("https", "wss")
        .replace("api", "chat")
        .replace("api", "ws") + "/v1/"
    : "";

  return {
    axios: context.axios,
    switching: context.switching,
    activeEndpoint: context.activeEndpoint,
    activeChatEndpoint,
    activeWSEndpoint
  };
}
